import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { ACC_ORDERS } from '@/store/entities/schema_types';
import { accountAccOrdersClient as client } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters('accOrders'),
  actions: {
    ...resourceActions,
    async load(ctx, { id, query = {} }) {
      try {
        const response = await client.list(id, query);

        const { data, meta } = response.data;

        const ids = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACC_ORDERS, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdsByParent',
          parentId: id,
          ids,
        });

        return Promise.resolve({ ids, meta });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
  },
};
